module.exports = __webpack_public_path__ + "img/15m_sprint.1bcbcd16.svg";